import { Dropdown } from "antd"
import { useMemo } from "react"
import { generateStreams } from "@/services/project/material-balance.service"
import { SimulationModal } from "@/services/project/simulation.service"
import { MenuOutlined } from "@ant-design/icons"

interface ProjectManagementMenuProps {
  sim?: SimulationModal | null
}
export const ProjectManagementMenu = (props: ProjectManagementMenuProps) => {
  const {sim} = props;
  const menus = useMemo(() => {
    return [
      {
        key: 'generateStream',
        label: 'Generate Streams',
        onClick: () => {
          if (sim?.id) {
            generateStreams(sim?.id)
          }
        }},
    ]
  }, [sim])

  const onItemClick = (item) => {
    if (item.key === "generateStream") {
      if (sim?.id) {
        generateStreams(sim?.id)
      }
    }
  }

  return <Dropdown menu={{items: menus, onClick: onItemClick}}>
    <MenuOutlined style={{fontSize: 28, cursor: 'pointer'}} />
  </Dropdown>
}